<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">访客机名称：</span>
        </div>
        <el-input v-model="deviceName" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">访客机序列号：</span>
        </div>
        <el-input v-model="deviceSn" size="small" style="width: 280px" />
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>

    </form>
  </div>
</template>

<script>
  import BreadCrumb from '../../../components/common/di-ding/common/bread-crumb'
  import {errorHandler} from '../../../utils/errorHandler'
  import InputTree from '../../../components/common/inputs/input-tree'
  import {pattern} from '../../../utils/regular'
  import {api} from '../../api/Visitor'
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import {nError, nSuccess} from '../../../utils/notice'
  import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'
  import {treeApi} from '../../api/TreeApi'
  // let a = document.getElementsByClassName()

  export default {
    components: {
      ButtonConfirmNext,
      ButtonConfirm,
      ButtonCancel,
      TextTitle,
      Breadcrumb,
      InputTree,
      BreadCrumb
    },
    name: 'controller-add',
    data () {
      return {
        config: {
          breadcrumb: [{
            value: '智慧访客',
            name: 'visitor-device-manage'
          }, {
            value: '访客机管理'
          }],
        },
        mainTitle: '添加访客机',
        subheading: '',

        deviceName: '',
        deviceSn: '',
      }
    },
    created () {

    },
    methods: {
      confirm () {
        if (!this.deviceName) {
          nError('请输入访客机名称')
          return false
        }
        if (!this.deviceSn) {
          nError('请输入访客机序列号')
          return false
        }
        this.$axios.post(api.addDevice, {
          deviceName: this.deviceName,
          deviceSn: this.deviceSn,
        })
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('添加成功')
              this.cancel()
            }
          })
          .catch(errorHandler('添加失败'))
      },
      cancel () {
        this.$router.go(-1)
      }
    },
    watch: {}
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 20px 0;
  }
  .form-line>span {
    font-size: 12px;
    color: #97a8be;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/view/VisitorCenter/VisitorDevice/VisitorDeviceAdd.vue